class MasonryGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log("Masonry Grid by PurplePanda Ecom");
    this.addEventListener("click", this.handleClicked.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClicked.bind(this));
  }

  handleClicked(event) {
    if (event.target.closest("[data-slide-index]")) {
      let slideNumber = parseInt(
        event.target
          .closest("[data-slide-index]")
          .getAttribute("data-slide-index")
      );
      const customEvent = new CustomEvent("PPModal:open", {
        detail: {
          slide: slideNumber,
        },
      });
      this.closest("section").dispatchEvent(customEvent);
    }
  }
}
customElements.define("masonry-grid", MasonryGrid);

class PurplePandaModal extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll(
      ".modal-content .modal-slide[data-slide-index]"
    );
    this.slideContent = this.querySelector(".modal-popup-image-container");
    this.content = this.querySelector(".modal-popup-container");
  }

  connectedCallback() {
    console.log("Modal Scroll Carousel by PurplePanda Ecom");
    this.selectSlide();
    this.addListeners();
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.handleKeys.bind(this));
    this.removeEventListener("click", this.handleClick.bind(this));
  }

  addListeners() {
    document.addEventListener("keydown", this.handleKeys.bind(this));
    this.addEventListener("click", this.handleClick.bind(this));
    this.closest("section").addEventListener(
      "PPModal:open",
      this.handleEvent.bind(this)
    );
  }

  handleEvent(event) {
    let nextSlide = event.detail.slide;
    this.selectSlide(nextSlide);
    this.open();
  }

  handleClick(event) {
    if (event.target.closest("[data-close]")) {
      this.close();
      return;
    }

    if (event.target.closest("[data-prev]")) {
      this.prevItem();
      return;
    }

    if (event.target.closest("[data-next]")) {
      this.nextItem();
      return;
    }

    if (event.target.closest("[data-slide-index]")) {
      let slideNumber = parseInt(
        event.target
          .closest("[data-slide-index]")
          .getAttribute("data-slide-index")
      );
      this.selectSlide(slideNumber);
      return;
    }
  }

  handleKeys({ key }) {
    if (!this.open) {
      return;
    }

    if (key === "Escape") {
      this.close();
    }
    if (key === "ArrowRight") {
      this.nextItem();
    }

    if (key === "ArrowLeft") {
      this.prevItem();
    }
  }

  nextItem() {
    this.selectSlide((this.currentSlide + 1) % this.slides.length);
  }

  prevItem() {
    let nextIndex =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.selectSlide(nextIndex);
  }

  selectSlide(index = 0) {
    this.currentSlide = index;
    let image;
    let videoObj;
    if (this.slides[index].querySelector(".modal-image-container video")) {
      image = this.slides[index]
        .querySelector(".modal-image-container video")
        .cloneNode(true);
    } else {
      image = this.slides[index]
        .querySelector(".modal-image-container img")
        .cloneNode(true);
    }

    this.slideContent.innerHTML = "";
    this.slideContent.appendChild(image);

    let content = this.slides[index].querySelector(".modal-info-container");
    this.content.innerHTML = content.innerHTML;
    this.selectAdjacentItems();
  }

  selectAdjacentItems() {
    const adjacentIndices = [];
    const numSlides = this.slides.length;

    // Calculate the indices of the three previous and three next items
    for (let i = -3; i <= 3; i++) {
      if (i !== 0) {
        // Skip adding the current index
        let index = (this.currentSlide + i) % numSlides;
        // Ensure the index is positive
        if (index < 0) {
          index += numSlides;
        }
        adjacentIndices.push(index);
      }
    }

    // Rearrange the indices to ensure correct ordering
    adjacentIndices.sort((a, b) => a - b);

    //Remove Duplicates
    let removedDuplicates = [...new Set(adjacentIndices)];
    let mobileGridContainer = this.querySelector(
      ".modal-container [data-inspiration] .mansory-grid-mini"
    );
    adjacentIndices.forEach((index) => {
      let imageContainer = this.slides[index]
        .querySelector(".modal-image-container")
        .cloneNode(true);
      mobileGridContainer.appendChild(imageContainer);
    });

    // Select the slides corresponding to the adjacent indices
  }

  open() {
    this.isOpen = true;
    this.classList.add("open");
    setTimeout(() => {
      this.setAttribute("open", true);
    }, "200");
  }

  close() {
    this.isOpen = false;
    this.classList.remove("open");
    setTimeout(() => {
      this.removeAttribute("open");
    }, "200");
  }
}
customElements.define("x-modal-pp", PurplePandaModal);

class KlaviyoButton extends HTMLButtonElement {
  constructor() {
    super();
    this.masterForm = document.querySelector(
      `#${this.getAttribute("data-form")}`
    );
  }

  connectedCallback() {
    this.masterForm.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.addEventListener("click", this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.masterForm.removeEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.removeEventListener("click", this.handleClick.bind(this));
  }

  handleVariantChange(e) {
    if (e.detail.variant) {
      e.detail.variant.available
        ? this.setAttribute("hidden", true)
        : this.removeAttribute("hidden");
    }
  }

  handleClick(e) {
    e.preventDefault();
    let formId = this.getAttribute("data-klaviyo");
    if (formId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push("openForm", formId);
    }
  }
}

customElements.define("klaviyo-button", KlaviyoButton, { extends: "button" });


 //PP-Gallery: Gallery onVariantChange Logic
document.documentElement.addEventListener("gallery:custom:change", (e) => {
  console.log(e);

  let variant = e.detail.variant;
  if (!variant) {
    return;
  }

  let productGalleryItems = document.querySelectorAll(
    "product-gallery [data-variants]"
  );
  let buttonItems = document.querySelectorAll(
    "product-gallery carousel-navigation button"
  );

  let thumbnails = document.querySelectorAll(
    "product-gallery-navigation button"
  );

  let currentSelectedImage = document.querySelector(
    '.product-gallery__thumbnail[aria-current="true"]'
  );


  productGalleryItems.forEach((item, index) => {

    let item_variants = JSON.parse(item.getAttribute("data-variants"));
    //console.log(item_variants, item_variants.includes(variant.id.toString()));
    if (!item_variants) {
      item.removeAttribute("hidden");
      buttonItems[index]?.removeAttribute("hidden");
      thumbnails[index]?.removeAttribute("hidden");
      //console.log("removed", item);
    } else {
      if (item_variants && item_variants.includes(variant.id.toString())) {
        item.removeAttribute("hidden");
        buttonItems[index]?.removeAttribute("hidden");
        thumbnails[index]?.removeAttribute("hidden");
      } else {
        item.setAttribute("hidden", true);
        buttonItems[index]?.setAttribute("hidden", true);
        thumbnails[index]?.setAttribute("hidden", true);
      }
    }

    let item_options = JSON.parse(item.getAttribute('data-options'));




    if(item_options && item_options.length){
      let hide = true;
      let downcased_options = [...variant.options].map((option) => {
        return option.toLowerCase();
      })

      item_options.forEach((option) => {
        if(downcased_options.includes(option)){
         hide = false;
        }
      })

      if(hide){
        item.setAttribute("hidden", true);
        buttonItems[index]?.setAttribute("hidden", true);
        thumbnails[index]?.setAttribute("hidden", true);
      }else{
        item.removeAttribute("hidden");
        buttonItems[index]?.removeAttribute("hidden");
        thumbnails[index]?.removeAttribute("hidden");
      }

    }

  });

  let firstButton = document.querySelector(
    "product-gallery carousel-navigation button:not([hidden])"
  );

  let remoteSlide = e.detail?.remoteSlide;
  let remoteSlideIndex = e.detail?.remoteSlideIndex;
  let gallery = document.querySelector("product-gallery scroll-carousel");

    gallery.select(remoteSlideIndex, {instant: true})
    let galleryNav = document.querySelector("product-gallery-navigation");
    console.log(galleryNav)
    if(galleryNav){
        let thumbs = galleryNav.querySelectorAll(`button:not([hidden])`);
        if(thumbs[remoteSlideIndex]){
          thumbs[remoteSlideIndex].click();
        }
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("gallery:filter:applied", { detail: { variant: variant, targetEl: gallery } })
    );

});

/* ----------------------------------------------------------------------------------------------- *
 * PDP mobil: Reihenfolge unterhalb der Buybox
 * -------------------------------------------------------------------------------------------------
 * Bloecke mit gesetztem Haken "Show below gallery on desktop" (die Akkordions und die Upselling-
 * Produkte) rendert Prestige in den Container #product-extra-information. Der ist ein eigener
 * Grid-Bereich der Produktseite. Ab 1000px liegt er links unter der Galerie, das ist gewollt und
 * bleibt unveraendert. Unter 1000px stapelt das Grid zu "Galerie / Buybox / Inhalte unter der
 * Galerie", der Container haengt damit am Seitenende statt an seiner Blockposition.
 *
 * Auf Mobil stellt diese Funktion deshalb her:
 *
 *   Buybox bis Shop-USPs
 *   Akkordions
 *   eigene Buttons und Popups am Ende der Buybox
 *   Start-up-Bereich (die abschliessenden Bild- und Textbloecke der Buybox)
 *   Upselling-Produkte
 *
 * Dazu wandert der Container an das Ende der Buybox und alles, was in der Buybox hinter den
 * Shop-USPs steht, in den Container, vor die Upselling-Produkte. Ab 1000px wird beides wieder
 * zurueckgesetzt, dort bleibt die Reihenfolge also genau die aus dem Editor.
 * ----------------------------------------------------------------------------------------------- */
(() => {
  // Ab dieser Breite gilt das zweispaltige Desktop-Raster, siehe sections/main-product.liquid.
  const desktopQuery = window.matchMedia("(min-width: 1000px)");

  // Die Bloecke am Ende der Buybox, die auf Mobil unter die Akkordions sollen. "button",
  // "modal" und "liquid" stehen mit in der Liste: der Konfigurator-Button ist ein Button-Block,
  // der Button fuer das Popup Sonderanfertigung ein Liquid-Block. Gelesen wird von hinten, ein
  // Block eines anderen Typs beendet die Reihe. Ein Button weiter oben in der Buybox bleibt
  // davon also unberuehrt.
  const trailingBlockTypes = ["image", "text", "button", "modal", "liquid"];

  // Die Upselling-Produkte innerhalb des Containers.
  const upsellingSelector = "product-recommendations";

  let trailingBlockIds = [];

  const readTrailingBlockIds = (blockList) => {
    const blocks = [...blockList.querySelectorAll(":scope > [data-block-id]")];
    const ids = [];

    for (let index = blocks.length - 1; index >= 0; index--) {
      if (!trailingBlockTypes.includes(blocks[index].dataset.blockType)) {
        break;
      }

      ids.unshift(blocks[index].dataset.blockId);
    }

    return ids;
  };

  // Setzt nodes in genau dieser Reihenfolge vor reference. Ohne reference ans Ende von container.
  // Bewegt nur, was noch nicht richtig steht, laeuft also ohne Debounce nicht in eine Schleife.
  const arrange = (container, nodes, reference) => {
    for (let index = nodes.length - 1; index >= 0; index--) {
      const node = nodes[index];
      const target = index === nodes.length - 1 ? reference : nodes[index + 1];

      if (target) {
        if (node.nextElementSibling !== target || node.parentElement !== target.parentElement) {
          target.before(node);
        }
      } else if (node.parentElement !== container || node.nextElementSibling !== null) {
        container.append(node);
      }
    }
  };

  const placeExtraInformation = () => {
    const extraInformation = document.getElementById("product-extra-information");
    const product = extraInformation && extraInformation.closest(".product");

    if (!product) {
      return;
    }

    const blockList = product.querySelector(".product-info__block-list");

    if (!blockList) {
      return;
    }

    // Nach einem Variantenwechsel sind die Bloecke neu gerendert, deshalb ueber die ID suchen.
    const trailingBlocks = trailingBlockIds
      .map((id) => product.querySelector('[data-block-id="' + id + '"]'))
      .filter(Boolean);

    if (desktopQuery.matches) {
      arrange(blockList, trailingBlocks, null);

      if (extraInformation.parentElement !== product || extraInformation.nextElementSibling !== null) {
        product.append(extraInformation);
      }

      return;
    }

    arrange(extraInformation, trailingBlocks, extraInformation.querySelector(upsellingSelector));

    if (extraInformation.parentElement !== blockList || extraInformation.nextElementSibling !== null) {
      blockList.append(extraInformation);
    }
  };

  const start = () => {
    const product = document.querySelector(".product");

    if (!product) {
      return;
    }

    const blockList = product.querySelector(".product-info__block-list");

    if (blockList) {
      trailingBlockIds = readTrailingBlockIds(blockList);
    }

    placeExtraInformation();

    // Breitenwechsel, etwa Geraetedrehung auf dem Tablet.
    desktopQuery.addEventListener("change", placeExtraInformation);
    window.addEventListener("resize", placeExtraInformation, { passive: true });

    // Ein Variantenwechsel rendert einzelne Buybox-Bloecke neu, danach neu einsortieren.
    new MutationObserver(placeExtraInformation).observe(product, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* ----------------------------------------------------------------------------------------------- *
 * PDP: die Groessenhilfe ueberlebt den Variantenwechsel
 * -------------------------------------------------------------------------------------------------
 * Die Section ss-size-guide legt ihren Schalter in ein <template> und schiebt ihn einmal beim Laden
 * per insertAdjacentElement vor das Ankerelement #ss-size-guide in die Variantenauswahl. Das ist
 * ein Verschieben, kein Kopieren: danach ist das <template> leer, nachgemessen mit
 * childElementCount gleich 0.
 *
 * Ein Variantenwechsel rendert die Variantenauswahl neu und wirft den Schalter damit weg. Weil das
 * <template> leer ist, kann die Section ihn nicht noch einmal einsetzen. Die Groessenhilfe war
 * dadurch bis zum Neuladen der Seite verschwunden, egal auf welche Variante gewechselt wurde.
 *
 * Diese Funktion haelt eine Referenz auf den Knoten. Nach einem Rerender haengt er nur noch im
 * Speicher, mit allen Klickhandlern der Section daran. Er wird deshalb genau dieser Knoten wieder
 * vor den Anker gesetzt und nicht kopiert. Eine Kopie haette die Handler verloren und das Popup
 * nicht mehr geoeffnet.
 * ----------------------------------------------------------------------------------------------- */
(() => {
  let schalter = null;

  const merken = () => {
    if (schalter) {
      return;
    }

    schalter = document.querySelector(".panori-size-guide")
      || document.querySelector('[class*="size-guide-template--"]');
  };

  const setzen = () => {
    merken();

    if (!schalter || schalter.isConnected) {
      return;
    }

    const anker = document.getElementById("ss-size-guide");

    if (anker) {
      anker.before(schalter);
    }
  };

  const start = () => {
    const info = document.querySelector(".product-info");

    if (!info) {
      return;
    }

    // Die Section setzt ihren Schalter verzoegert, deshalb nicht sofort merken.
    window.setTimeout(merken, 1000);

    new MutationObserver(setzen).observe(info, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();